export class ListDataCatalogPipelineVersionsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "versions",
            "baseName": "versions",
            "type": "Array<DataCatalogPipeline>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogPipelineVersionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
